import React, { PropsWithChildren } from "react";
import { useSortable } from "@dnd-kit/react/sortable";

interface DashboardWidgetProps extends PropsWithChildren {
    id: string;
    index: number;
}

export default function DashboardWidget({
                                            id,
                                            index,
                                            children,
                                        }: DashboardWidgetProps) {
    const {
        ref,
        sourceRef,
        targetRef,
        isDragging,
    } = useSortable({
        id,
        index,
    });

    const setRefs = (node: HTMLElement | null) => {
        ref(node);
        sourceRef(node);
        targetRef(node);
    };

    return (
        <article
            ref={setRefs}
            className={`dashboard-widget${isDragging ? " dashboard-widget--dragging" : ""}`}
        >
            {children}
        </article>
    );
}
